export const GET_SUBSCRIBERS = 'GET_SUBSCRIBERS';
export const GET_SUBSCRIBERS_SUCCESS = 'GET_SUBSCRIBERS_SUCCESS';
export const GET_SUBSCRIBERS_ERROR = 'GET_SUBSCRIBERS_ERROR';

export const SET_SUBSCRIBER = 'SET_SUBSCRIBER';
